import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, SplitButton, SplitButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { UserApi } from '../../../../../../redux/api/UserApi';
import * as svg from '@progress/kendo-svg-icons';
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';

const RelatedButton: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    return (
        <Button disabled={ticket.Is_Loading} className='related-button' onClick={() => navigate('related')} title={`Open Tickets: ${ticket.Contact_Name} / ${ticket.Company_Name}`} svgIcon={svg.clockArrowRotateIcon} size='large' >{`${ticket.Open_User_Tickets > 99 ? '99+' : ticket.Open_User_Tickets} / ${ticket.Open_Client_Tickets > 99 ? '99+' : ticket.Open_Client_Tickets}`}</Button>
    );
};

export default RelatedButton;